import gql from 'graphql-tag';

export const UpdateParticipantTaskTemplate = gql`
  mutation UpdateParticipantTaskTemplate(
    $organizationId: ID!
    $participantTaskTemplateId: ID!
    $request: UpdateParticipantTaskTemplateRequest!
  ) {
    updateParticipantTaskTemplate(
      organizationId: $organizationId
      participantTaskTemplateId: $participantTaskTemplateId
      request: $request
    ) {
      id
      name
      requiresDueDate
      recurrence {
        intervalDays
        completedAt
      }
      labels {
        id
        name
        color
        description
      }
      createdAt
      updatedAt
    }
  }
`;
